import { WHITE, VL_BLACK, MID_GREY } from "../../utils/colours";

// In px
export const FIELD_WIDTH = 245;
export const NARROW_FIELD_WIDTH = 70;
export const DEFAULT_FIELD_HEIGHT = 34;
export const LARGE_FIELD_HEIGHT = 44;

interface InputStylingProps {
    largeFontSize?: boolean;
    large?: boolean;
    fullWidth?: boolean;
    narrowWidth?: boolean;
    error?: boolean;
    variant?: 'light' | 'dark';
}

export const inputStyling = ({ 
    largeFontSize, 
    large, 
    fullWidth, 
    narrowWidth, 
    error, 
    variant 
}: InputStylingProps): string => `
    display: block;
    height: ${large ? LARGE_FIELD_HEIGHT : DEFAULT_FIELD_HEIGHT}px;
    width: ${
        fullWidth
            ? '100%'
            : narrowWidth
            ? `${NARROW_FIELD_WIDTH}px`
            : `${FIELD_WIDTH}px`
    };
    padding: 6px 12px;
    font-size: ${large || largeFontSize ? 16 : 14}px;
    border-radius: 4px;
    font-weight: 100;

    ${variant === 'light' ? `
        color: ${VL_BLACK()};
        background-color: ${WHITE()};
        border: 1px solid ${MID_GREY};
        
        ::placeholder {
            color: ${VL_BLACK(50)};
        }
    ` : `
        color: ${WHITE()};
        background-color: ${WHITE(15)};
        border: 1px solid ${WHITE()};

        ::placeholder {
            color: ${WHITE(50)};
        }
    `};

    @media (pointer: coarse) {
        /* Increase font size of input fields on touch devices */
        font-size: ${large || largeFontSize ? 18 : 16}px;
    }
    
    ${error ? `&:not(:focus) { border-color: red; }` : ''}
`;
